import React from 'react';
import PromoCodesTable from '@/features/dashboard/discounts/components/PromoCodesTable.tsx';

const PromoCodesPage = () => {
  return <PromoCodesTable />;
};

export default PromoCodesPage;
